import { Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';

import { of } from 'rxjs';
import { map, mergeMap, catchError, tap } from 'rxjs/operators';

import { UserActions } from '../actions/user.actions';
import { RolesService } from 'app/core/roles/roles.service';

type Action = UserActions;
@Injectable()
export class UserInfoEffects {
    constructor(
        private actions$: Actions,
        private rolesService: RolesService
    ) {}

    userInfo$ = createEffect(() =>
        this.actions$.pipe(
            ofType(`[Roles] Get Roles`),
            mergeMap(() =>
                this.rolesService.getAllRoles().pipe(
                    map((userRoles) => ({
                        type: '[User Roles] User Roles',
                        payload: userRoles,
                    }))
                )
            )
        )
    );
}
